<div id="content" class="allcp-form" ng-controller="CustomerAccountController" ng-init="init()">
    <div ng-include="'modules/customer/partials/top_menu.html'"></div>
        <div class="row">
            <div class="panel-body pr10 pl10">
                <div class="col-md-9">
                    <form class="form-horizontal" ng-submit="updateCustomerInfo()">              
                        <div class="form-group">
                            <label for="store-name" class="col-md-3 control-label">Yetkili Adı:</label>
                            <div class="col-md-9">
                                <label for="store-name" class="field prepend-icon">
                                    <input type="text" name="store-name" id="business-name" placeholder="Yetkili Adı" class="gui-input" ng-model="customer.user.first_name">
                                    <label for="store-name" class="field-icon">
                                        <i class="fa fa-user"></i>
                                    </label>
                                </label>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="store-name" class="col-md-3 control-label">Yetkili Soyadı:</label>
                            <div class="col-md-9">
                                <label for="store-name" class="field prepend-icon">
                                    <input type="text" name="store-name" id="business-name" placeholder="Yetkili Soyadı" class="gui-input" ng-model="customer.user.last_name">
                                    <label for="store-name" class="field-icon">
                                        <i class="fa fa-user"></i>
                                    </label>
                                </label>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="store-phone" class="col-md-3 control-label">Telefon:</label>

                            <div class="col-md-9">
                                <label for="store-phone" class="field prepend-icon">
                                    <input type="text" name="store-phone" id="store-phone" placeholder="Telefon" class="gui-input" ng-model="customer.customer.phone_number">
                                    <label for="store-phone" class="field-icon">
                                        <i class="fa fa-phone"></i>
                                    </label>
                                </label>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="store-email" class="col-md-3 control-label">Email:</label>

                            <div class="col-md-9">
                                <label for="store-email" class="field prepend-icon">
                                    <input type="text" name="store-email" id="store-email" class="gui-input" placeholder="Email" ng-model="customer.user.email" disabled="true">
                                    <label for="store-email" class="field-icon">
                                        <i class="fa fa-envelope-o"></i>
                                    </label>
                                </label>
                            </div>
                        </div>
                    
                        <div class="form-group">
                            <label for="store-desc" class="col-md-3 control-label">Adres:</label>
                            <div class="col-md-9">
                                <label class="field prepend-icon">
                                    <textarea class="gui-textarea" id="store-desc" name="store-desc" ng-model="customer.customer.address" placeholder="Adres"></textarea>
                                    <label for="store-desc" class="field-icon">
                                        <i class="fa fa-location-arrow"></i>
                                    </label>
                                </label>
                            </div>
                        </div>
                    
                        <div class="form-group">
                            <div class="col-md-12">
                                <div class="pull-right">
                                    <button type="submit" class="btn btn-primary btn-block">Güncelle</button>
                                </div>
                            </div>
                        </div>
                        
                    </form>
                </div>
                <div class="col-md-3 mtn20">
                    <div class="allcp-form theme-primary">
                        <h6 class="mb15">Logo</h6>
                        <div class="fileupload fileupload-new" data-provides="fileupload">
                            <div class="fileupload-preview thumbnail mb20">
                                <img 
                                    class="img-responsive center"
                                    ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ customer.customer.logo }}"
                                />
                            </div>
                            <div class="logo_upload" ng-repeat="item in logo.queue">
                                <div class="progress" ng-if="proccessProfile">
                                    <div class="progress-bar progress-bar-success  progress-bar-striped active" 
                                    role="progressbar" 
                                    aria-valuenow="60" 
                                    aria-valuemin="0" 
                                    aria-valuemax="100" 
                                    ng-style="{ 'width': item.progress + '%' }">
                                    </div>
                                </div>
                            </div>
                            <span class="btn btn-primary light btn-file btn-block ph5">
                                <span class="fileupload-new">Logo Yükle</span>
                                <input type="file" nv-file-select uploader="logo">
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>